import { FC } from "react";
import QuestLabs from "../../../../components/QuestLabs";
import { StreakFooterProps } from "../component/StreakTypes";
import { useStreak } from "./StreakContextType";

export const StreakFooter: FC<StreakFooterProps> = ({
  footerText,
  footerLink,
}) => {
  const { themeManager, showFooter } = useStreak();

  if (!showFooter) return null;
  return (
    <QuestLabs
      style={themeManager.getFooterStyles()}
      text={footerText}
      link={footerLink}
    />
  );
};
